import cns from 'classnames'
import { useWeb3 } from 'modules/blockChain/hooks/useWeb3'
import { Text } from 'shared/ui/common/Text'
import { useNFCSState } from 'modules/nfcs/hooks/useNFCSState'
import { NFCSFormStep } from 'modules/nfcs/types'

import { ReactComponent as WarningMarkSVG } from 'assets/warningMark.svg'
import { ReactComponent as CheckSVG } from 'assets/check.svg'

import s from './NFCSFormPrimaryAddressSign.module.scss'

type Props = {
  nfcsMode: 'mint' | 'update'
  isLoading: boolean
  onClick: () => void
}

export const NFCSFormPrimaryAddressSign = (props: Props) => {
  const { nfcsMode, isLoading, onClick } = props
  const { walletAddress } = useWeb3()
  const { signedAddresses, currentFormStep, signs } = useNFCSState()
  const primaryAddress = signedAddresses[0] as string | undefined

  const isAddressSigned = Boolean(primaryAddress && signs[primaryAddress])

  const isDisabled =
    primaryAddress !== walletAddress || isAddressSigned || isLoading

  if (!walletAddress) return null

  if (currentFormStep !== NFCSFormStep.Finish) {
    return (
      <span>
        This is <b>primary address</b> in the bundle. It will
        <br />
        be used for the loan payout.{' '}
        {nfcsMode === 'mint' && (
          <>
            If you want to
            <br />
            change this, restart the flow
          </>
        )}
      </span>
    )
  }

  return (
    <div className={s.wrap}>
      <Text className={s.tag} size={16} color="secondary">
        Primary
      </Text>
      <button
        className={cns(s.button, {
          [s.isSigned]: isAddressSigned,
        })}
        disabled={isDisabled}
        onClick={onClick}
      >
        {isAddressSigned ? (
          <>
            <CheckSVG />
            <span>Already has been signed</span>
          </>
        ) : (
          <>
            <WarningMarkSVG />
            <span>
              You need to <b>Sign this Address</b>
            </span>
          </>
        )}
      </button>
    </div>
  )
}
